import { render } from "./CreateWorkstationPreviewModal.vue?vue&type=template&id=48165cce&ts=true"
import script from "./CreateWorkstationPreviewModal.vue?vue&type=script&lang=ts"
export * from "./CreateWorkstationPreviewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__